// extracted by mini-css-extract-plugin
export default {"title":"OpportunityDetails_title__SpMHV","topics":"OpportunityDetails_topics__HGmrA","customDivider":"OpportunityDetails_customDivider__8saX+"};